import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=f4371850&scoped=true"
import script from "./CenterBottom.vue?vue&type=script&lang=js"
export * from "./CenterBottom.vue?vue&type=script&lang=js"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&id=f4371850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4371850",
  null
  
)

export default component.exports